import { Injectable } from '@angular/core';
import { Xpoint } from '@xpointtech/capacitor';
import { Config } from '../config/config.service';
import {
  XPOINT_LOCAL_TEST_JWT,
  XpointVerifyParams,
  XpointVerifyResult,
} from './xpoint-check.model';

@Injectable({ providedIn: 'root' })
export class XpointCheckService {
  constructor(private readonly _config: Config) {}

  async verify({
    action,
    userIdentifier,
    xpointKey,
  }: XpointVerifyParams): Promise<XpointVerifyResult> {
    try {
      if (this._config.CONFIG.xpointDisabled) {
        return { status: 'allowed', jwt: XPOINT_LOCAL_TEST_JWT };
      }

      const jurisdictions = await Xpoint.resolveJurisdiction({
        client: xpointKey,
      });

      if (!jurisdictions.preferableArea) {
        return { status: 'blocked', jwt: null };
      }

      const result = await Xpoint.check({
        client: xpointKey,
        customData: JSON.stringify({ action }),
        user: btoa(userIdentifier),
        jurisdiction: jurisdictions.preferableArea,
      });

      if (!result?.jwt) {
        return { status: 'error', jwt: null };
      }

      return result.allowed
        ? { status: 'allowed', jwt: result.jwt }
        : { status: 'blocked', jwt: result.jwt };
    } catch {
      return { status: 'error', jwt: null };
    }
  }
}
